<template>
  <div class="text-center">
    <div class="inline-block">
        <span class="font-bold">{{$t("Labels.Time")}}</span>
        <vs-input-number :min="min" v-model="timeEdit" class="text-xs"/>
    </div>
    <div  class="inline-block ml-5">
      <span class="font-bold">{{$t("Labels.TimeUnity")}}</span>
      <v-select :options="timeOptions" v-model="unityEdit"  :clearable="false"/>
    </div>
  </div>
</template>
<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  props: {
    time: Number,
    unity: String
  },
  data () {
    return {
      timeEdit: 0,
      unityEdit: '',
      timeOptions: [
        { label: 'Segundos', value: 'seconds' },
        { label: 'Minutos', value: 'minutes' },
        { label: 'Horas', value: 'hours' }
      ]
    }
  },
  watch: {
    timeEdit (val) {
      this.$emit('time', val)
    },
    unityEdit (val) {
      if (val.value === 'seconds' && this.timeEdit < 11) { this.timeEdit = 11 }
      this.$emit('unity', val.value)
    }
  },
  computed: {
    min () {
      return this.unityEdit.value === 'seconds' ? 11 : 0
    }
  },
  created () {
    this.timeEdit = this.time || 0
    switch (this.unity) {
      case 'seconds':
        this.unityEdit = { label: 'Segundos', value: 'seconds' }
        break
      case 'minutes':
        this.unityEdit = { label: 'Minutos', value: 'minutes' }
        break
      case 'hours':
        this.unityEdit = { label: 'Horas', value: 'hours' }
        break
      default:
        this.unityEdit = { label: 'Segundos', value: 'seconds' }
        break
    }
  }
}
</script>
